import translate from "../services/translation/lang";

export default function Loading({message}) {

  const byElbetLoading = "img/by-elbet-loading.png";
  const logo = "img/logo.png";

  return (
    <div className="loading">
      <div className="loading-top">
        {!message ? (<div className="loading-text">
          {translate("loading")}
           <div className="loading-dots"></div>
        </div>) : <div className="text-center">
          <img className="loading-by-elbet" src={logo} alt="logo" />
          </div>}
        {message ? (<p className="login-error">{message === "STALE" ? "Multisession is not allowed" : message}</p>) : null}
      </div>
      <div className="loading-bottom">
        <img className="loading-by-elbet" src={byElbetLoading} alt="by-elbet" />
      </div>
    </div>
  );
}
